import React from 'react'

interface IAddress {
  address: string
  keyword: string
}

type Word = {
  value: string
  isKeyword: boolean
}

const Address: React.FC<IAddress> = ({ address, keyword }) => {
  if (keyword === '') {
    return <span>{address}</span>
  } else {
    const keywordIndexList: number[] = []
    let position = 0

    while (true) {
      let index = address.indexOf(keyword, position)

      if (index != -1) {
        keywordIndexList.push(index)

        position = index + keyword.length
      } else {
        break
      }
    }

    if (!keywordIndexList.length) {
      return <span>{address}</span>
    } else {
      const res: Word[] = []
      let pre = 0

      for (let i = 0; i < keywordIndexList.length; i++) {
        const index = keywordIndexList[i]

        const str = address.substring(pre, index)

        if (str) {
          res.push({
            value: str,
            isKeyword: false
          })
        }

        res.push({
          value: keyword,
          isKeyword: true
        })

        pre = index + keyword.length
      }

      if (pre < address.length) {
        res.push({
          value: address.substring(pre),
          isKeyword: false
        })
      }

      return (
        <>
          {res.map(({ value, isKeyword }, index) => (
            <span key={index} className={isKeyword ? 'keyword' : ''}>
              {value}
            </span>
          ))}
        </>
      )
    }
  }
}

export default Address
